import {
  AddLayoutRequest,
  LayoutEndpoints,
  LayoutUpdateRequest,
  SiteControlLayout,
  UserSettings,
  UserSettingsEndpoints,
} from '@scaleaq/sitecontrol-lib';
import { useAuth } from 'react-oidc-context';

import { API_NAMES, CACHE_KEYS } from '@/constants';
import {
  useAuthApiDeleteById,
  useAuthApiGetSingleFetch,
  useAuthApiPost,
  useAuthApiUpdate,
  useAuthApiUpdateById,
} from '@/dataAccess/rest/apiHooks';

export const useGetAllLayoutsByUser = () => {
  const { user } = useAuth();
  return useAuthApiGetSingleFetch<SiteControlLayout[]>({
    baseApiRoute: API_NAMES.cloudUserconfigApi,
    cacheKeys: [CACHE_KEYS.userConfigLayout, user?.profile.email ?? ''],
    route: LayoutEndpoints.getMyLayouts,
    refetchOnWindowFocus: false,
  });
};

export const useAddLayout = () => {
  return useAuthApiPost<AddLayoutRequest, SiteControlLayout>({
    baseApiRoute: API_NAMES.cloudUserconfigApi,
    cacheKeys: [CACHE_KEYS.userConfigLayout],
    route: LayoutEndpoints.addLayout,
    returnJsonResult: true,
  });
};

export const useUpdateLayout = () => {
  return useAuthApiUpdateById<LayoutUpdateRequest, SiteControlLayout>({
    baseApiRoute: API_NAMES.cloudUserconfigApi,
    cacheKeys: [CACHE_KEYS.userConfigLayout],
    route: LayoutEndpoints.updateLayout,
  });
};

export const useDeleteLayoutById = () => {
  return useAuthApiDeleteById<SiteControlLayout>({
    baseApiRoute: API_NAMES.cloudUserconfigApi,
    cacheKeys: [CACHE_KEYS.userConfigLayout],
    route: LayoutEndpoints.deleteLayoutById,
  });
};

export const useGetMyUserSettings = () => {
  return useAuthApiGetSingleFetch<UserSettings>({
    baseApiRoute: API_NAMES.cloudUserconfigApi,
    cacheKeys: [CACHE_KEYS.userConfigSettings],
    route: UserSettingsEndpoints.getMyUserSettings,
  });
};

export const useUpdateMyUserSettings = () => {
  return useAuthApiUpdate<UserSettings>({
    baseApiRoute: API_NAMES.cloudUserconfigApi,
    cacheKeys: [],
    route: UserSettingsEndpoints.updateMyUserSettings,
  });
};
